

document.addEventListener("DOMContentLoaded", function() {


const h2Element1 = document.querySelector('#shopify-section-template--18287313125544__rich_text_RRHjEC > div > div > div > h2:nth-child(1)');

  // Check if the element exists
  if (h2Element1) {
    // Get the current text
    const originalText1 = h2Element1.textContent;

    // Use a regular expression to replace the dollar amount with a strike-through version
    const updatedText1 = originalText1.replace(/\$\d{1,3}(,\d{3})*/g, (match) => {
        return `<span style="text-decoration: line-through;">${match}</span>`;
    });

    // Update the h2 element's inner HTML
    h2Element1.innerHTML = updatedText1;
}

});

